import { useEffect, useState } from "react";
import { HardDrive, Trash2, ShieldCheck, Database } from "lucide-react";
import api from "@/lib/api";
import { CinematicStage, StageHeader, GlassCard, Spinner } from "@/components/shared";

export default function Storage() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/storage/summary").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s) return <Spinner label="Loading Storage…" />;
  const pct = Math.min(100, Math.round((s.estimated_mb / s.quota_mb) * 100));

  return (
    <CinematicStage>
      <StageHeader stage="OPS" room="The Archive · Storage" icon={HardDrive} title="Minimal by design"
        subtitle="Your studio keeps only what matters. Generated media can be auto-deleted after download." />

      <div className="grid lg:grid-cols-3 gap-6">
        <GlassCard className="p-6 lg:col-span-2">
          <div className="flex items-center gap-3 mb-6"><HardDrive className="w-5 h-5 text-[#5B4DFF]" /><h3 className="font-display font-semibold">Usage</h3></div>
          <div className="flex items-end justify-between mb-2">
            <span className="font-display text-3xl font-bold">{s.estimated_mb} MB</span>
            <span className="text-slate-500 text-sm">of {(s.quota_mb / 1000).toFixed(0)} GB</span>
          </div>
          <div className="h-3 rounded-full bg-white/10 overflow-hidden">
            <div className="h-full bg-gradient-to-r from-[#5B4DFF] to-[#FFB300]" style={{ width: `${pct}%` }} />
          </div>
          <div className="grid grid-cols-3 gap-4 mt-6">
            <Stat label="Projects" value={s.projects} />
            <Stat label="Media files" value={s.media_files} />
            <Stat label="Artifacts" value={s.artifacts} />
          </div>
        </GlassCard>

        <GlassCard className="p-6">
          <div className="flex items-center gap-3 mb-4"><ShieldCheck className="w-5 h-5 text-[#FFB300]" /><h3 className="font-display font-semibold">Retained data</h3></div>
          <div className="space-y-2">
            {s.retained.map((r) => <div key={r} className="flex items-center gap-2 text-sm text-slate-300"><Database className="w-3.5 h-3.5 text-[#5B4DFF]" /> {r}</div>)}
          </div>
          <button className="mt-6 w-full inline-flex items-center justify-center gap-2 py-2.5 rounded-xl bg-white/5 border border-white/10 text-slate-300 hover:text-white text-sm" data-testid="storage-cleanup-button">
            <Trash2 className="w-4 h-4" /> Clean temporary media
          </button>
        </GlassCard>
      </div>
    </CinematicStage>
  );
}

function Stat({ label, value }) {
  return (
    <div className="rounded-xl bg-white/5 border border-white/10 p-4 text-center">
      <div className="font-display text-2xl font-bold">{value}</div>
      <div className="text-xs text-slate-500 mt-1">{label}</div>
    </div>
  );
}
